export default __webpack_public_path__ + "static/media/undraw_resume.8001e591.svg";